import React from "react";
import { Link } from "react-router-dom";

// La carcasa de tarjeta estaba reescrita a mano unas ocho veces, y dos de las
// copias (Noticias y Podcast) usaban otro modelo de hover —`hover:shadow-md`
// suelto— por lo que ni siquiera se elevaban como el resto. De ahí que las
// rejillas se vieran distintas de una página a otra.
//
// Se renderiza como <Link>, <a> o <div> según reciba `to`, `href` o ninguno,
// para no obligar a cada llamada a repetir el mismo condicional.
export default function Card({
  children,
  to,
  href,
  className = "",
  padded = false,
  interactive,
  as: Tag = "div",
  ...rest
}) {
  const isLink = Boolean(to || href);
  const clickable = interactive ?? isLink;

  const classes = [
    "bg-card rounded-3xl overflow-hidden border border-border",
    clickable ? "card-hover focus-ring" : "",
    padded ? "p-6" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (to) {
    return (
      <Link to={to} className={`group block ${classes}`} {...rest}>
        {children}
      </Link>
    );
  }

  if (href) {
    const external = /^https?:\/\//.test(href);
    return (
      <a
        href={href}
        className={`group block ${classes}`}
        {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <Tag className={classes} {...rest}>
      {children}
    </Tag>
  );
}

/** Cuerpo de tarjeta con el espaciado estándar. */
export function CardBody({ children, className = "" }) {
  return <div className={`p-6 ${className}`}>{children}</div>;
}
